import React from "react";
import { Navigate } from "react-router-dom";

const Login = React.lazy(() => import("../pages/auth/Login"));
const ForgotPassword = React.lazy(() => import("../pages/auth/ForgotPassword"));
const UserLogin = React.lazy(() => import("../pages/auth/UserLogin"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const OtpVerification = React.lazy(() => import("../pages/auth/OtpVerification"));
const Dashboard1 = React.lazy(() => import("../pages/dashboard"));
const Partners = React.lazy(() => import("../pages/partners"));
const PartnerDetails = React.lazy(() => import("../pages/partners/show"));
const Customer = React.lazy(() => import("../pages/customer"));
const FittingPartner = React.lazy(() => import("../pages/fittingPartner"));
const Employee = React.lazy(() => import("../pages/employees"));
const Cart = React.lazy(() => import("../pages/cart"));
const Calendar = React.lazy(() => import("../pages/calendars/calendar"));
const Appoinment = React.lazy(() => import("../pages/calendars/appoinment"));
const QuoteManagement = React.lazy(() => import("../pages/quoteManagement"));
const Profile = React.lazy(() => import("../pages/profile"));
const TyreProduct = React.lazy(() => import("../pages/product/typreProduct"));
const ShowTyreProduct = React.lazy(() => import("../pages/product/typreProduct/show"));
const CreateTyreProduct = React.lazy(() => import("../pages/product/typreProduct/create"));
const UpdateTyreProduct = React.lazy(() => import("../pages/product/typreProduct/update"));
const WheelProduct = React.lazy(() => import("../pages/product/wheelProduct"));
const ShowWheelProduct = React.lazy(() => import("../pages/product/wheelProduct/show"));
const CreateWheelProduct = React.lazy(() => import("../pages/product/wheelProduct/create"));
const UpdateWheelProduct = React.lazy(() => import("../pages/product/wheelProduct/update"));
const BatteryProduct = React.lazy(() => import("../pages/product/batteryProduct"));
const ShowBatteryProduct = React.lazy(() => import("../pages/product/batteryProduct/show"));
const CreateBatteryProduct = React.lazy(() => import("../pages/product/batteryProduct/create"));
const UpdateBatteryProduct = React.lazy(() => import("../pages/product/batteryProduct/update"));
const Order = React.lazy(() => import("../pages/order"));
const OrderDetails = React.lazy(() => import("../pages/order/show"));
const UpdateOrderDetails = React.lazy(() => import("../pages/order/UpdateOrderDetails"));
const Report = React.lazy(() => import("../pages/report"));
const Invoice = React.lazy(() => import("../pages/invoice"));
const InvoiceDetails = React.lazy(() => import("../pages/invoice/invoicePreview"));
const StockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases"));
const CreateStockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases/create"));
const ShowStockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases/show"));
const UpdateStockPurchases = React.lazy(() => import("../pages/stockManagement/stockPurchases/update"));
const StockAdjustments = React.lazy(() => import("../pages/stockManagement/stockAdjustments"));
const Suppliers = React.lazy(() => import("../pages/stockManagement/suppliers"));
const ShowSuppliers = React.lazy(() => import("../pages/stockManagement/suppliers/show"));
const StockPayments = React.lazy(() => import("../pages/stockManagement/stockPayments"));
const CreateStockPayments = React.lazy(() => import("../pages/stockManagement/stockPayments/create"));
const ShowStockPayments = React.lazy(() => import("../pages/stockManagement/stockPayments/show"));
const ExpenseSheets = React.lazy(() => import("../pages/expenseSheets"));
const CreateExpenseSheets = React.lazy(() => import("../pages/expenseSheets/create"));
const ShowExpenseSheets = React.lazy(() => import("../pages/expenseSheets/show"));
const Inquiry = React.lazy(() => import("../pages/inquiries"));
const ShowInquiry = React.lazy(() => import("../pages/inquiries/show"));
const WebContentSettings = React.lazy(() => import("../pages/webcontentsettings"));
const VehicleType = React.lazy(() => import("../pages/webcontentsettings/vehicleType"));
const Membership = React.lazy(() => import("../pages/webcontentsettings/membership"));
const Tax = React.lazy(() => import("../pages/webcontentsettings/tax"));
const BudgetType = React.lazy(() => import("../pages/webcontentsettings/budgetType"));
const TyreBrand = React.lazy(() => import("../pages/webcontentsettings/brand/tyreBrand"));
const WheelBrand = React.lazy(() => import("../pages/webcontentsettings/brand/wheelBrand"));
const BatteryBrand = React.lazy(() => import("../pages/webcontentsettings/brand/batteryBrand"));
const TyreModel = React.lazy(() => import("../pages/webcontentsettings/model/tyreModel"));
const WheelModel = React.lazy(() => import("../pages/webcontentsettings/model/wheelModel"));
const BatteryModel = React.lazy(() => import("../pages/webcontentsettings/model/batteryModel"));
const State = React.lazy(() => import("../pages/webcontentsettings/state"));
const City = React.lazy(() => import("../pages/webcontentsettings/city"));
const Suburb = React.lazy(() => import("../pages/webcontentsettings/suburb"));
const Question = React.lazy(() => import("../pages/webcontentsettings/question"));
const Services = React.lazy(() => import("../pages/webcontentsettings/services"));
const Promo = React.lazy(() => import("../pages/webcontentsettings/promo"));
const Page = React.lazy(() => import("../pages/pageContent/page"));
const HomeBanner = React.lazy(() => import("../pages/pageContent/homeBanner"));
const OfferBanner = React.lazy(() => import("../pages/pageContent/offerBanner"));
const CompanyInfo = React.lazy(() => import("../pages/pageContent/companyInfo"));
const SocialMediaLink = React.lazy(() => import("../pages/pageContent/socialMediaLink"));
const YouTube = React.lazy(() => import("../pages/pageContent/youTube"));
const FAQ = React.lazy(() => import("../pages/pageContent/faq"));
const MobileServices = React.lazy(() => import("../pages/mobileServices"));
const Review = React.lazy(() => import("../pages/review"));
const Blog = React.lazy(() => import("../pages/blog"));
const Feedback = React.lazy(() => import("../pages/feedback"));
const Account = React.lazy(() => import("../pages/account"));
const CellForecast = React.lazy(() => import("../pages/cellForecast"));
const Error500 = React.lazy(() => import("../pages/Error500"));
const Error404 = React.lazy(() => import("../pages/Error404"));

export const ROUTES = {
  LOGIN: {
    path: "/auth/login",
    element: <Login />,
    isProtected: false,
  },
  FORGOT_PASSWORD: {
    path: "/auth/forgot-password",
    element: <ForgotPassword />,
    isProtected: false,
  },
  USER_LOGIN: {
    path: "/auth/user-login",
    element: <UserLogin />,
    isProtected: false,
  },
  LOGOUT: {
    path: "/auth/logout",
    element: <Logout />,
    isProtected: false,
  },
  OTP_VERIFICATION: {
    path: "/auth/otp-verification",
    element: <OtpVerification />,
    isProtected: false,
  },
  DASHBOARD: {
    path: "/dashboard",
    element: <Dashboard1 />,
    isProtected: true,
  },
  PROFILE: {
    path: "/profile",
    element: <Profile />,
    isProtected: true,
  },
  CART: {
    path: "/cart",
    element: <Cart />,
    isProtected: true,
  },
  PARTNERS: {
    path: "/partners",
    element: <Partners />,
    isProtected: true,
  },
  PARTNER_DETAILS: {
    path: "/partner/show",
    element: <PartnerDetails />,
    isProtected: true,
  },
  FITTING_PARTNER: {
    path: "/fitting-partner",
    element: <FittingPartner />,
    isProtected: true,
  },
  EMPLOYEE: {
    path: "/employee",
    element: <Employee />,
    isProtected: true,
  },
  CUSTOMER: {
    path: "/customer/:key",
    element: <Customer />,
    isProtected: true,
  },
  CALENDAR: {
    path: "/calendar",
    element: <Calendar />,
    isProtected: true,
  },
  APPOINMENT: {
    path: "/appoinment",
    element: <Appoinment />,
    isProtected: true,
  },
  QUOTE: {
    path: "/quote",
    element: <QuoteManagement />,
    isProtected: true,
  },
  TYRE_PRODUCT: {
    path: "/product/tyre-product",
    element: <TyreProduct />,
    isProtected: true,
  },
  SHOW_TYRE_PRODUCT: {
    path: "/product/tyre-product/show",
    element: <ShowTyreProduct />,
    isProtected: true,
  },
  CREATE_TYRE_PRODUCT: {
    path: "/product/tyre-product/create",
    element: <CreateTyreProduct />,
    isProtected: true,
  },
  UPDATE_TYRE_PRODUCT: {
    path: "/product/tyre-product/update",
    element: <UpdateTyreProduct />,
    isProtected: true,
  },
  WHEEL_PRODUCT: {
    path: "/product/wheel-product",
    element: <WheelProduct />,
    isProtected: true,
  },
  SHOW_WHEEL_PRODUCT: {
    path: "/product/wheel-product/show",
    element: <ShowWheelProduct />,
    isProtected: true,
  },
  CREATE_WHEEL_PRODUCT: {
    path: "/product/wheel-product/create",
    element: <CreateWheelProduct />,
    isProtected: true,
  },
  UPDATE_WHEEL_PRODUCT: {
    path: "/product/wheel-product/update",
    element: <UpdateWheelProduct />,
    isProtected: true,
  },
  BATTERY_PRODUCT: {
    path: "/product/battery-product",
    element: <BatteryProduct />,
    isProtected: true,
  },
  SHOW_BATTERY_PRODUCT: {
    path: "/product/battery-product/show",
    element: <ShowBatteryProduct />,
    isProtected: true,
  },
  CREATE_BATTERY_PRODUCT: {
    path: "/product/battery-product/create",
    element: <CreateBatteryProduct />,
    isProtected: true,
  },
  UPDATE_BATTERY_PRODUCT: {
    path: "/product/battery-product/update",
    element: <UpdateBatteryProduct />,
    isProtected: true,
  },
  ORDER: {
    path: "/order",
    element: <Order />,
    isProtected: true,
  },
  ORDER_DETAILS: {
    path: "/order/order-details",
    element: <OrderDetails />,
    isProtected: true,
  },
  UPDATE_ORDER_DETAILS: {
    path: "/order/update-order-details",
    element: <UpdateOrderDetails />,
    isProtected: true,
  },
  REPORT: {
    path: "/report",
    element: <Report />,
    isProtected: true,
  },
  INVOICE: {
    path: "/invoice",
    element: <Invoice />,
    isProtected: true,
  },
  INVOICE_DETAILS: {
    path: "/invoice/invoice-details",
    element: <InvoiceDetails />,
    isProtected: true,
  },
  STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases",
    element: <StockPurchases />,
    isProtected: true,
  },
  CREATE_STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases/create",
    element: <CreateStockPurchases />,
    isProtected: true,
  },
  SHOW_STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases/show",
    element: <ShowStockPurchases />,
    isProtected: true,
  },
  UPDATE_STOCK_PURCHASES: {
    path: "/stock-management/stock-purchases/update",
    element: <UpdateStockPurchases />,
    isProtected: true,
  },
  STOCK_ADJUSTMENTS: {
    path: "/stock-management/stock-adjustments",
    element: <StockAdjustments />,
    isProtected: true,
  },
  SUPPLIERS: {
    path: "/stock-management/suppliers",
    element: <Suppliers />,
    isProtected: true,
  },
  SHOW_SUPPLIERS: {
    path: "/stock-management/suppliers/show",
    element: <ShowSuppliers />,
    isProtected: true,
  },
  STOCK_PAYMENTS: {
    path: "/stock-management/stock-payments",
    element: <StockPayments />,
    isProtected: true,
  },
  CREATE_STOCK_PAYMENTS: {
    path: "/stock-management/stock-payments/create",
    element: <CreateStockPayments />,
    isProtected: true,
  },
  SHOW_STOCK_PAYMENTS: {
    path: "/stock-management/stock-payments/show",
    element: <ShowStockPayments />,
    isProtected: true,
  },
  EXPENSE_SHEETS: {
    path: "/expense-sheets",
    element: <ExpenseSheets />,
    isProtected: true,
  },
  CREATE_EXPENSE_SHEETS: {
    path: "/expense-sheets/create",
    element: <CreateExpenseSheets />,
    isProtected: true,
  },
  SHOW_EXPENSE_SHEETS: {
    path: "/expense-sheets/show",
    element: <ShowExpenseSheets />,
    isProtected: true,
  },
  INQUIRY: {
    path: "/inquiry",
    element: <Inquiry />,
    isProtected: true,
  },
  SHOW_INQUIRY: {
    path: "/inquiry/show",
    element: <ShowInquiry />,
    isProtected: true,
  },
  WEB_CONTENT_SETTINGS: {
    path: "/web-content-settings/:key",
    element: <WebContentSettings />,
    isProtected: true,
  },
  BUDGET_TYPE: {
    path: "/web-content-settings/budget-type",
    element: <BudgetType />,
    isProtected: true,
  },
  VEHICLE_TYPE: {
    path: "/web-content-settings/vehicle-type",
    element: <VehicleType />,
    isProtected: true,
  },
  MEMBERSHIP: {
    path: "/web-content-settings/membership",
    element: <Membership />,
    isProtected: true,
  },
  TAX: {
    path: "/web-content-settings/tax",
    element: <Tax />,
    isProtected: true,
  },
  TYRE_BRAND: {
    path: "/web-content-settings/tyre-brand",
    element: <TyreBrand />,
    isProtected: true,
  },
  WHEEL_BRAND: {
    path: "/web-content-settings/wheel-brand",
    element: <WheelBrand />,
    isProtected: true,
  },
  BATTERY_BRAND: {
    path: "/web-content-settings/battery-brand",
    element: <BatteryBrand />,
    isProtected: true,
  },
  TYRE_MODEL: {
    path: "/web-content-settings/tyre-model",
    element: <TyreModel />,
    isProtected: true,
  },
  WHEEL_MODEL: {
    path: "/web-content-settings/wheel-model",
    element: <WheelModel />,
    isProtected: true,
  },
  BATTERY_MODEL: {
    path: "/web-content-settings/battery-model",
    element: <BatteryModel />,
    isProtected: true,
  },
  STATE: {
    path: "/web-content-settings/state",
    element: <State />,
    isProtected: true,
  },
  CITY: {
    path: "/web-content-settings/city",
    element: <City />,
    isProtected: true,
  },
  SUBURB: {
    path: "/web-content-settings/suburb",
    element: <Suburb />,
    isProtected: true,
  },
  QUESTION: {
    path: "/web-content-settings/question",
    element: <Question />,
    isProtected: true,
  },
  SERVICE: {
    path: "/web-content-settings/services",
    element: <Services />,
    isProtected: true,
  },
  PROMO: {
    path: "/web-content-settings/promo",
    element: <Promo />,
    isProtected: true,
  },
  PAGE: {
    path: "/page-content/page",
    element: <Page />,
    isProtected: true,
  },
  HOME_BANNER: {
    path: "/page-content/home-banner",
    element: <HomeBanner />,
    isProtected: true,
  },
  OFFER_BANNER: {
    path: "/page-content/offer-banner",
    element: <OfferBanner />,
    isProtected: true,
  },
  COMPANY_INFO: {
    path: "/page-content/:key",
    element: <CompanyInfo />,
    isProtected: true,
  },
  SOCIAL_MEDIA_LINK: {
    path: "/page-content/social-media-link",
    element: <SocialMediaLink />,
    isProtected: true,
  },
  YOU_TUBE: {
    path: "/page-content/you-tube",
    element: <YouTube />,
    isProtected: true,
  },
  FAQ: {
    path: "/page-content/faq",
    element: <FAQ />,
    isProtected: true,
  },
  MOBILE_SERVICES: {
    path: "/mobile-services/:key",
    element: <MobileServices />,
    isProtected: true,
  },
  REVIEW: {
    path: "/review",
    element: <Review />,
    isProtected: true,
  },
  BLOG: {
    path: "/blog",
    element: <Blog />,
    isProtected: true,
  },
  FEEDBACK: {
    path: "/feedback",
    element: <Feedback />,
    isProtected: true,
  },
  ACCOUNT: {
    path: "/account",
    element: <Account />,
    isProtected: true,
  },
  CELL_FORECAST: {
    path: "/cell-forecast",
    element: <CellForecast />,
    isProtected: true,
  },
  ERROR500: {
    path: "/500",
    element: <Error500 />,
    isProtected: false,
  },
  ERROR404: {
    path: "/404",
    element: <Error404 />,
    isProtected: false,
  },
  DEFAULT: {
    path: "*",
    element: <Navigate to={"/404"} replace />,
    isProtected: false,
  },
};


export const routes = Object.values(ROUTES);
